import _get from 'lodash.get';

import { SET_WEB_APP_PREFERENCE, SET_WEB_APP_PREFERENCE_FAILURE, SET_WEB_APP_PREFERENCE_SUCCESS } from './actions';

export const get = (key: string | string[]) => {
  const path = Array.isArray(key) ? key.filter(Boolean) : [key].filter(Boolean);

  if (path.length) {
    return _get(window.top!.__INITIAL_STATE__.user.preferences, path);
  }

  return window.top!.__INITIAL_STATE__.user.preferences;
};

export const getLanguage = () => get('language');
export const getTimezone = () => get('timeZone');

export const getDateFormat = (type: string) => get(['dateFormat', type]);
export const getDateFormatShort = () => getDateFormat('short');
export const getDateFormatMedium = () => getDateFormat('medium');
export const getDateFormatLong = () => getDateFormat('long');

export const getNumberFormat = (type: string) => get(['numberFormat', type]);
export const getThousandsSeparator = () => getNumberFormat('thousandsSeparator');
export const getDecimalSeparator = () => getNumberFormat('decimalSeparator');

export const setWebAppPreference = (key: string, value: TSFixMe, callback?: () => void) => {
  const makeAsyncFunction = window.top!.store.promiseListener.createAsyncFunction({
    start: SET_WEB_APP_PREFERENCE,
    resolve: SET_WEB_APP_PREFERENCE_SUCCESS,
    reject: SET_WEB_APP_PREFERENCE_FAILURE,
  });

  makeAsyncFunction.asyncFunction({ key, value }).then(() => callback && callback());

  window.top!.__INITIAL_STATE__.user.preferences.webApp[key] = value;
};
